import { render, staticRenderFns } from "./AppPane3.vue?vue&type=template&id=2dabc3b7&scoped=true&"
import script from "./AppPane3.vue?vue&type=script&lang=js&"
export * from "./AppPane3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabc3b7",
  null
  
)

export default component.exports